module.exports = "<link *ngIf=\"changeDynamicCss\" rel=\"stylesheet\" type=\"text/css\" [href]=\"ColorUrl\">\r\n<angular-loader></angular-loader>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main